import { Row } from "./shared";


export function ReceiptConfirmModal({ receiptConfirm, associados, onCancel, onConfirm }) {
  return (
        <div
          data-testid="receipt-confirm-modal"
          className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
          onClick={() => onCancel()}
        >
          <div
            className="bg-white max-w-md w-full rounded-sm shadow-xl border border-slate-200"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="px-6 py-5 border-b border-slate-100">
              <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500">
                Emitir Recibo
              </div>
              <h3 className="mt-1 font-serif-display text-2xl leading-tight">
                Confirmar emissão?
              </h3>
            </div>
            <div className="px-6 py-5 space-y-3 text-sm">
              {(() => {
                const assocId = (receiptConfirm.assigned_to || []).find(
                  (a) => a !== "__all__"
                );
                const assoc = associados.find((u) => u.id === assocId);
                return (
                  <>
                    <Row label="Boleto" value={receiptConfirm.title} />
                    <Row
                      label="Nº do boleto"
                      value={receiptConfirm.numero_boleto || "—"}
                    />
                    <Row
                      label="Associado"
                      value={assoc?.name || assocId || "—"}
                    />
                    <Row
                      label="Valor"
                      value={
                        receiptConfirm.valor
                          ? new Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            }).format(Number(receiptConfirm.valor))
                          : "—"
                      }
                    />
                  </>
                );
              })()}
              <div className="bg-amber-50 border border-amber-200 text-amber-800 text-xs px-3 py-2 rounded-sm mt-2">
                Ao confirmar, o número do recibo será <strong>igual ao número
                do boleto</strong> e o boleto será marcado como{" "}
                <strong>PAGO</strong>.
              </div>
            </div>
            <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-2">
              <button
                data-testid="receipt-confirm-cancel"
                onClick={() => onCancel()}
                className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:bg-white"
              >
                Cancelar
              </button>
              <button
                data-testid="receipt-confirm-ok"
                onClick={() => onConfirm(receiptConfirm)}
                className="px-4 py-2 bg-[#002776] text-white text-[11px] uppercase tracking-[0.22em] hover:bg-[#001a5a]"
              >
                Confirmar e emitir
              </button>
            </div>
          </div>
        </div>
  );
}
